import {
  JOBS_INTERVIEW_ACCEPT_REQUEST,
  JOBS_INTERVIEW_ACCEPT_SUCCESS,
  JOBS_INTERVIEW_ACCEPT_FAIL,
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const JobsInterviewPlannedAcceptReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOBS_INTERVIEW_ACCEPT_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case JOBS_INTERVIEW_ACCEPT_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case JOBS_INTERVIEW_ACCEPT_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};

export default JobsInterviewPlannedAcceptReducer;
